import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "blobjs";
import "canvas-toBlob";
import { saveAs } from "file-saver";

class DownLoad extends Component {
  constructor(props) {
    super(props);
    this.onDlButtonClick = this.onDlButtonClick.bind(this);
  }
  onDlButtonClick(e) {
    e.preventDefault();
    this.props.canvas.toBlob(blob =>
      saveAs(blob, "reproduction-sur-quadrillage.png")
    );
  }
  render() {
    return (
      <button
        className="btn btn-primary"
        onClick={this.onDlButtonClick}
        title="Télécharger l'image"
      >
        <span className="glyphicon glyphicon-download-alt" />
      </button>
    );
  }
}

DownLoad.propTypes = {
  canvas: PropTypes.shape({
    toBlob: PropTypes.func.isRequired
  }).isRequired
};

const mapStateToProps = ({ canvas }) => ({ canvas });

export default connect(mapStateToProps)(DownLoad);
